module.exports = __webpack_public_path__ + "../public/img/background-login.ae923aa3.png";